// import { Link } from "react-router-dom";
// import { useEffect, useState } from "react";

// function PoliticsPage() {
//   const [items, setItems] = useState([]);

//   useEffect(() => {
//     fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=politics")
//       .then(res => res.json())
//       .then(data => setItems(data))
//       .catch(() => setItems([]));
//   }, []);

//   // split logic:
//   const regionalAPTS = items.filter(i => /\b(AP|TS)\b/i.test(i.title));
//   const regional = items.filter(i => !/\b(AP|TS)\b/i.test(i.title) && !/international/i.test(i.title));
//   const international = items.filter(i => /international/i.test(i.title));

//   return (
//     <div className="container mt-5">
//       <h1 className="text-center mb-4">Politics</h1>

//       <div className="d-flex justify-content-center">
//         <div className="d-flex w-100" style={{ maxWidth: 1200 }}>
//           <div className="flex-fill me-3">
//             <div className="p-3 shadow rounded bg-white h-100 d-flex flex-column">
//               <h3 className="text-center mb-3">Regional (AP and TS)</h3>
//               <div className="flex-grow-1 overflow-auto">
//                 {regionalAPTS.map(a => (
//                   <Link key={a._id} to={`/article/${a._id}`} className="text-decoration-none">
//                     <div className="card mb-3 p-2 article-card">
//                       <h6>{a.title}</h6>
//                       <p className="mb-0 text-muted">{a.content.slice(0,120)}...</p>
//                     </div>
//                   </Link>
//                 ))}
//                 {regionalAPTS.length === 0 && <p className="text-muted">No AP/TS items</p>}
//               </div>
//             </div>
//           </div>

//           <div style={{ width: 360, minWidth: 280 }}>
//             <div className="d-flex flex-column h-100" style={{ gap: 16 }}>
//               <div className="p-3 shadow rounded bg-white mb-3">
//                 <h5 className="text-center mb-3">Regional</h5>
//                 {regional.map(r => (
//                   <Link key={r._id} to={`/article/${r._id}`} className="text-decoration-none">
//                     <div className="card mb-2 p-2 article-card">
//                       <h6>{r.title}</h6>
//                       <p className="mb-0 text-muted">{r.content.slice(0,100)}...</p>
//                     </div>
//                   </Link>
//                 ))}
//                 {regional.length === 0 && <p className="text-muted">No regional items</p>}
//               </div>

//               <div className="p-3 shadow rounded bg-white">
//                 <h5 className="text-center mb-3">International</h5>
//                 {international.map(i => (
//                   <Link key={i._id} to={`/article/${i._id}`} className="text-decoration-none">
//                     <div className="card mb-2 p-2 article-card">
//                       <h6>{i.title}</h6>
//                       <p className="mb-0 text-muted">{i.content.slice(0,100)}...</p>
//                     </div>
//                   </Link>
//                 ))}
//                 {international.length === 0 && <p className="text-muted">No international items</p>}
//               </div>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// }
// export default PoliticsPage;
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

function PoliticsPage() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetch("https://movie-backend-1wmv.onrender.com/api/articles?category=politics")
      .then(res => res.json())
      .then(data => setItems(data))
      .catch(() => setItems([]));
  }, []);

  // 🔥 Filter by type field (NOT title)
  const regional = items.filter(i => i.subcategory?.toLowerCase() === "regional");
  const national = items.filter(i => i.subcategory?.toLowerCase() === "national");
  const international = items.filter(i => i.subcategory?.toLowerCase() === "international");

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Politics</h1>

      <div className="d-flex justify-content-center">
        <div className="d-flex w-100" style={{ maxWidth: 1200 }}>

          {/* LEFT — REGIONAL */}
          <div className="flex-fill me-3">
            <div className="p-3 shadow rounded bg-white h-100 d-flex flex-column">
              <h3 className="text-center mb-3">Regional</h3>

              <div className="flex-grow-1 overflow-auto">
                {regional.map(a => (
                  <Link key={a._id} to={`/article/${a._id}`} className="text-decoration-none">
                    <div className="card mb-3 p-2 article-card">
                      <h6>{a.title}</h6>
                      <p className="mb-0 text-muted">{a.content.slice(0, 120)}...</p>
                    </div>
                  </Link>
                ))}

                {regional.length === 0 && <p className="text-muted">No regional items.</p>}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE — NATIONAL + INTERNATIONAL */}
          <div style={{ width: 360, minWidth: 280 }}>
            <div className="d-flex flex-column h-100" style={{ gap: 16 }}>

              {/* NATIONAL BLOCK */}
              <div className="p-3 shadow rounded bg-white mb-3">
                <h5 className="text-center mb-3">National</h5>

                {national.map(n => (
                  <Link key={n._id} to={`/article/${n._id}`} className="text-decoration-none">
                    <div className="card mb-2 p-2 article-card">
                      <h6>{n.title}</h6>
                      <p className="mb-0 text-muted">{n.content.slice(0, 100)}...</p>
                    </div>
                  </Link>
                ))}

                {national.length === 0 && <p className="text-muted">No national items</p>}
              </div>

              {/* INTERNATIONAL BLOCK */}
              <div className="p-3 shadow rounded bg-white">
                <h5 className="text-center mb-3">International</h5>

                {international.map(i => (
                  <Link key={i._id} to={`/article/${i._id}`} className="text-decoration-none">
                    <div className="card mb-2 p-2 article-card">
                      <h6>{i.title}</h6>
                      <p className="mb-0 text-muted">{i.content.slice(0, 100)}...</p>
                    </div>
                  </Link>
                ))}

                {international.length === 0 && <p className="text-muted">No international items</p>}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PoliticsPage;
